import classNames from 'classnames';
import React, { Component } from 'react';
import { IL10N } from '../../Common/l10n-keys';
import ProgressBar from '../progressBar/progressBar';
import styles from './paging.scss';
import * as helper from '../../Common/html-helper';
import TabNavigationHelper from '../../Common/tabNavigationHelper';

const getPagingString = (l10n: IL10N, count: number, isFsp: boolean | undefined) => {
    const [single, multiple] = isFsp ? [l10n.lookedSet, l10n.lookedSets] : [l10n.lookedArticle, l10n.lookedArticles];
    return count === 1 ? single : multiple;
}

export default class Paging extends Component<
    {
        viewedArticleNumber: number,
        totalArticleCount: number,
        waitingForResponse: boolean,
        onLoadMore,
        l10n: IL10N,
        totalPagesNumber: number,
        currentPageNumber: number,
        showHiddenLinks: boolean,
        url?: string,
        isFsp?: boolean
        customDataTestIdAttName?: string,
        customSemanticTestIdAttName?: string
    },
    { mounted: boolean }> {
    private readonly dataTestIdAttName;
    private readonly semanticTestIdAttName;

    constructor(props) {
        super(props);

        this.dataTestIdAttName = this.props.customDataTestIdAttName ? 
            this.props.customDataTestIdAttName : 'paging_button';
        this.semanticTestIdAttName = this.props.customSemanticTestIdAttName ? 
            this.props.customSemanticTestIdAttName : 'paging_button';

        this.state =
        {
            mounted: false
        };

        this.handleLoadMoreClick = this.handleLoadMoreClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount(): void {
        this.setState({ mounted: true })
    }

    private handleLoadMoreClick() {
        this.props.onLoadMore();
    }

    private handleKeyDown(event) {
        if (event.key === ' ') { // space btn
            event.preventDefault();
            this.props.onLoadMore(true);
        }
    }

    private hiddenLink() {
        const params = (new URL(this.props.url));
        const urlStart = params.protocol + '//' + params.host + params.pathname;
        const listItem = [];
        for (let i = 2; i <= this.props.totalPagesNumber; i++) {
            listItem.push(< a href={`${urlStart}?page=${i}`} key={i}
                aria-label={'hiddenLink page=' + i}></a >);
        }
        return listItem;
    }

    public render() {
        const pagingString = helper.decodeHTML(
            getPagingString(this.props.l10n, this.props.totalArticleCount, this.props.isFsp)
                .replace('{0}', (this.props.viewedArticleNumber).toString())
                .replace('{1}', this.props.totalArticleCount.toString())
        );
        return (
            <div className={styles.paging}>
                {this.state.mounted && <React.Fragment><div className={classNames(styles.paging_text,
                    {
                        [styles.invert_color]: this.state.mounted &&
                            helper.isPageBackgroundBlack()
                    })}>
                    {pagingString}
                </div></React.Fragment>}
                {this.props.totalArticleCount > 0 &&
                    <div className={styles.paging_bar}>
                        <ProgressBar currentValue={this.props.viewedArticleNumber}
                            maxValue={this.props.totalArticleCount} />
                    </div>
                }
                {this.props.currentPageNumber < this.props.totalPagesNumber &&
                    <button className={classNames(styles.paging_button,
                        { [styles.disabled]: this.props.waitingForResponse })}
                        data-testid={this.dataTestIdAttName} data-semantic-id={this.semanticTestIdAttName}
                        onClick={this.handleLoadMoreClick}
                        onKeyDown={this.handleKeyDown}
                        ref={(el) => TabNavigationHelper.instance.setFocusAtt(el)}
                    >
                        <span>
                            {helper.decodeHTML(this.props.l10n.viewMoreProducts)}
                        </span>
                    </button>
                }
                {this.props.url && this.props.showHiddenLinks &&
                    <div className={styles.hidden_paging}>
                        {this.hiddenLink()}
                    </div>
                }
            </div>
        );
    }
}

